import { createContext } from 'react-router';

/**
 * Describes the user that's making the request
 */
export type UserContextValue = {
  id: string;
  type: 'user' | 'admin';
  /**
   * For `user`, this is the role within the tenant (company) they're logged into.
   * `null` until a tenant session has been resolved.
   */
  role: 'owner' | 'manager' | 'employee' | 'admin' | (string & {}) | null;
  scopes: string[];
  displayName?: string;
  profile: {
    name?: string;
    email?: string;
  };
};

/**
 * `null` when there's no signed-in user.
 * Seeded on every navigation from `getRouterContext` (see `browser.client.ts`).
 */
export const UserContext = createContext<UserContextValue | null>(null);

/**
 * To hold the information describing the company that
 * the user is logged into
 */
export type CompanyContextValue = {
  domain: string;
  id: string;
  publicId: string;
  displayName?: string;
  enabledServices: string[];
};

/**
 * `null` outside of the `/app/:domain` routes.
 * Populated by `companyMiddleware` (see `browser.client.ts`).
 */
export const CompanyContext = createContext<CompanyContextValue | null>(null);
